import React, { Component } from 'react';
import UIComponent from 'components/UiComponent';
import { withRouter } from 'components/Routing';
import ReactDOM from "react-dom";
import AppContext from 'components/appContext';
import {withTranslation} from "react-i18next";

class UserPortalSelection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rolesOptions : [],
        }

        this.availableRoles = [
            {
                value: 'TRAINEE',
                description: this.props.t("lbl.TRAINEE_PORTAL",'Trainee Portal'),
                order:1,
            },
            {
                value: 'SUPERVISOR',
                description: this.props.t("lbl.SUPERVISOR_PORTAL",'Supervisor Portal'),
                order:2,
            },
            {
                value: 'STUDENT',
                description: this.props.t("lbl.STUDENT_PORTAL",'Student Portal'),
                order:3,
            },
            {
                value: 'ADMIN',
                description: this.props.t("lbl.SYSTEM_ADMINISTRATOR",'System Administrator'),
                order:4,
            },
        ];

        this.initialValue = null;
    }

    componentDidUpdate(prevProps) {
        if (Object.keys(this.props.userDetails).length > 0 && this.props.userDetails.hasOwnProperty("ROLES") && !this.state.rolesOptions.length) {
            let userRoles = this.props.userDetails.ROLES.split(",");
            let rolesOptions = [];
            userRoles.forEach((userRole) => {
                this.availableRoles.forEach((availableRole) => {
                    if (userRole.toUpperCase() == availableRole.value){
                        rolesOptions.push(availableRole);
                    }
                });
            });
            if(this.props.userDetails.CURRENT_ROLE){
                this.availableRoles.forEach((availableRole) => {
                    if (this.props.userDetails.CURRENT_ROLE.toUpperCase() == availableRole.value){
                        this.initialValue = availableRole;
                        return;
                    }
                });
            }else{
                this.initialValue = rolesOptions[0];
            }
            
            this.setState({
                // sort roles options by order in ascending order
                rolesOptions: rolesOptions.sort((a,b) => a.order - b.order),
            });
        }
    }
    
    onShow() {
        ReactDOM.findDOMNode(this.props.drawer).classList.add("full-width");
    }

    onHide() {
        ReactDOM.findDOMNode(this.props.drawer).classList.remove("full-width");
    }

    render() {
        return (
            <React.Fragment>
                {this.state.rolesOptions.length && this.initialValue ?
                    <React.Fragment>
                        <div className="user-details__portal">
                            <UIComponent
                                component="multiselect"
                                name="portal"
                                id="portal"
                                selectValues={this.initialValue.value}
                                selectDescriptions={this.initialValue.description}
                                order="ASC"
                                onChange={({VALUE}) => {
                                    this.context.set('showCurrentPortalInfo', false);
                                    this.props.toggleDrawer(false);
                                    this.props.setUserDetails({CURRENT_ROLE : VALUE[0]});
                                    this.context.set('drawerOpen', false);
                                    this.context.set('showCurrentPortalInfo', true);
                                    this.props.router.navigate('/');
                                }}
                                keyField="value"
                                descField="description"
                                options={this.state.rolesOptions}
                                showCloseFilterButton
                                clearSelectionText=""
                                single
                                showTitleBar
                                title={this.props.t("lbl.PORTAL","Portal")}
                                onDropdownShow={this.onShow.bind(this)}
                                onDropdownHide={this.onHide.bind(this)}
                                readOnly={this.state.rolesOptions.length > 1 ? false : true}
                            />
                        </div>
                    </React.Fragment>
                    :
                    null
                }
            </React.Fragment>
        )
    }
}


const UserPortalSelectionWithRouter = withRouter(UserPortalSelection);
export default withTranslation()(UserPortalSelectionWithRouter);
UserPortalSelection.contextType = AppContext;